import React, { useState, useEffect } from 'react';
import Gallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import '../assets/css/CustomGallery.css';

const MyGallery = () => {
  const [imageObjects, setImageObjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        // Try JSON file first (works in development/localhost)
        let response = await fetch('/Gallery/images.json');
        let data = null;
        
        if (response.ok) {
          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            data = await response.json();
          } else {
            // Not JSON, try parsing anyway
            const text = await response.text();
            try {
              data = JSON.parse(text);
            } catch (e) {
              // Not valid JSON, try PHP
              response = await fetch('/Gallery/images.php');
              if (response.ok) {
                const phpText = await response.text();
                // Check if PHP was executed (should be JSON) or raw PHP code
                if (!phpText.trim().startsWith('<?php') && !phpText.trim().startsWith('<!')) {
                  data = JSON.parse(phpText);
                }
              }
            }
          }
        } else {
          // JSON doesn't exist, try PHP (for production server)
          response = await fetch('/Gallery/images.php');
          if (response.ok) {
            const text = await response.text();
            // Check if PHP was executed (should be JSON) or raw PHP code
            if (!text.trim().startsWith('<?php') && !text.trim().startsWith('<!')) {
              data = JSON.parse(text);
            }
          }
        }
        
        if (data && data.images && data.images.length > 0) {
          const totalImages = data.images.length;
          const images = data.images.map((image, index) => {
            // URL encode the image path to handle spaces and special characters
            const encodedImage = encodeURI(image);
            
            // Extract folder name from image path
            // Path format: /Gallery/GALLERY 1/folder name/image.jpg
            const pathParts = image.split('/');
            let folderName = '';
            if (pathParts.length > 3) {
              // Get the folder name (usually the part before the filename)
              folderName = pathParts[pathParts.length - 2] || '';
            } else if (pathParts.length === 3) {
              // If image is directly in Gallery folder, use "Gallery" as folder name
              folderName = 'Gallery';
            }
            
            // Format: "Folder Name - currentImage/totalImages"
            const description = folderName 
              ? `${folderName} - ${index + 1}/${totalImages}`
              : `${index + 1}/${totalImages}`;
            
            return {
              original: encodedImage,
              thumbnail: encodedImage,
              description: description,
            };
          });
          setImageObjects(images);
        } else {
          setImageObjects([]);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error loading gallery images:', error);
        setLoading(false);
        setImageObjects([]);
      }
    };

    fetchImages();
  }, []);

  if (loading) {
    return (
      <section className="ftco-section ftco-no-pb">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 heading-section ftco-animate text px-4">
              <h2 className="mb-4 text-success text-center">Gallery</h2>
              <p className="text-center">Loading images...</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (imageObjects.length === 0) {
    return (
      <section className="ftco-section ftco-no-pb">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 heading-section ftco-animate text px-4">
              <h2 className="mb-4 text-success text-center">Gallery</h2>
              <p className="text-center">No images found. Please add images to /public/Gallery/ folder and update /public/Gallery/images.json</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="ftco-section ftco-no-pb">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 heading-section ftco-animate text px-4">
            <h2 className="mb-4 text-success text-center">Gallery</h2>
          </div>
        </div>
        
        <div className="row">
          <div className="col-md-12">
            <div className="text">
              <Gallery 
                items={imageObjects}
                autoPlay={true}
                showPlayButton={true}
                showThumbnails={true}
                slideInterval={4000}
                showFullscreenButton={true}
                showBullets={false}
                lazyLoad={true}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MyGallery;
